import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Card,
  TextField,
  Box,
  Button,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { AddCircle, East, West } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

const StorageSection = ({
  handleNext,
  handleBack,
  totalStorageEmission,
  setTotalStorageEmission,
}) => {
  const [entries, setEntries] = useState(totalStorageEmission);
  const [type, setType] = useState("");
  const [electricityUsed, setElectricityUsed] = useState("");
  const [totalEmissionStorage, setTotalEmissionStorage] = useState(0);

  const handleAddEntry = () => {
    if (type && electricityUsed) {
      const newEntry = {
        type,
        electricityUsed: parseFloat(electricityUsed),
        emission: calculateEmission(type, electricityUsed),
      };

      setEntries([...entries, newEntry]);
      setTotalStorageEmission([...totalStorageEmission, newEntry]);
      // setTotalEmissionStorage(totalEmissionStorage + newEntry.emission);

      // Reset input fields after adding an entry
      setType("");
      setElectricityUsed("");
    }
  };

  const handleDeleteEntry = (index) => {

    const updatedEntries = entries.filter((entry, i) => i !== index);
    setEntries(updatedEntries);
    setTotalStorageEmission(updatedEntries);
  };

  const calculateEmission = (type, electricityUsed) => {
    const emissionFactor = {
      Cold: 0.874,
      Traditional: 0.874,
    };
    return emissionFactor[type] * parseFloat(electricityUsed);
  };

  useEffect(() => {
    const calculatedTotalEmission = entries
      .map((entry) => entry.emission)
      .reduce((acc, current) => acc + current, 0);
    setTotalEmissionStorage(calculatedTotalEmission);
  }, [entries]);

  return (
    <div>
      <Grid
        container
        fullWidth
        justifyContent="center"
        mx="auto"
        mb={4}
        mt="20%"
        borderRadius={4}
        p={2}
        xs={12}
        style={{
          boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
          background:
            "linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa",
        }}
      >
        <Grid item xs={12} flex fullWidth>
          <Typography ml={2} mb={2} variant="h4">
            Storage
          </Typography>
        </Grid>

        <Card
          elevation={2}
          boxShadow={2}
          sx={{ width: "100%", py: 2, borderRadius: 6 }}
        >
          <Grid container xs={12} flex fullWidth>
            <Grid fullWidth item xs={12} md={6} py={2} px={4}>
              <Typography variant="h6">Select type</Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Storage</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={type}
                    label="Storage "
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                  >
                    <MenuItem value={"Cold"}>Cold</MenuItem>
                    <MenuItem value={"Traditional"}>Traditional</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid fullWidth item xs={12} md={6} py={2} px={4}>
              <Typography variant="h6">Electricity consumed</Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <TextField
                    label="in kWh"
                    variant="outlined"
                    value={electricityUsed}
                    onChange={(event) => {
                      setElectricityUsed(event.target.value);
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              md={3}
              mt={2}
              mx="auto"
              alignItems="end"
              justifyContent="end"
            >
              <Button
                fullWidth
                variant="contained"
                onClick={handleAddEntry}
                color="primary"
                endIcon={<AddCircle />}
              >
                ADD MORE
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      {totalStorageEmission === null ? (
        <Typography></Typography>
      ) : (
        <Box>
          {totalStorageEmission.map((entry, index) => (
            <Card sx={{ my: 4 }} key={index} elevation={4} boxShadow={6}>
              <Box my={2} p={2} display="flex" flexDirection="row">
                <Grid my="auto" mx="1rem" container>
                  <Grid item xs={12} md={2}>
                    <Typography variant="h6">{entry.type} Storage</Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="h6">
                      Electricity Used:{entry.electricityUsed} kWh
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="h6">
                      Emission:{entry.emission} kgCo2eq
                    </Typography>
                  </Grid>
                  <Grid item xs={6} mx="auto" md={2}>
                    <Button
                      variant="outlined"
                      onClick={() => handleDeleteEntry(index)}
                      color="error"
                      endIcon={<DeleteIcon />}
                    >
                      DELETE
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          ))}
        </Box>
      )}

      {totalEmissionStorage !== 0 && (
        <Box mb="7rem">
          <div>Total Emission: {totalEmissionStorage.toFixed(3)} kg CO2</div>
        </Box>
      )}

      <Grid
        item
        flex
        xs={11}
        mx="auto"
        mb={8}
        px={4}
        sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none" } }}
      >
        <Box mx="auto">
          <Button
            variant="outlined"
            onClick={handleBack}
            startIcon={<West />}
            sx={{ mt: 1, ml: 1, width: "6rem" }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            endIcon={<East />}
            sx={{ mt: 1, ml: 2, width: "6rem" }}
          >
            Next
          </Button>
        </Box>
      </Grid>
    </div>
  );
};

export default StorageSection;
